/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { DatabaseSnapshot, AngularFireAction } from '@angular/fire/compat/database';
import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { DefaultSplitDataRenderType } from '@touchplan/common';
import { CustomFieldDefinition, ICustomFieldDefinition } from 'src/app/app-data/models/CustomFieldDefinition';
import { CustomFieldDropDownDefinition } from 'src/app/app-data/models/CustomFieldDropDownDefinition';
import { LocalAction } from '../base/LocalSnapshot';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { IFancyIdJoin } from '../base/FancyIdJoin';

export class CustomFieldDefinitionList
	extends FancyFirebaseSplitDataList<
		ICustomFieldDefinition,
		DefaultSplitDataRenderType,
		CustomFieldDefinition
	>
	implements IFancyIdJoin
{
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: IFancyIdJoin) {
		super(angularLand, path, fancyJoins);
	}

	public $$added(action: LocalAction<DatabaseSnapshot<any>>) {
		const definition = new CustomFieldDefinition(action.payload.key);
		if (action.type === 'child_added') {
			// firebase
			definition.databaseUpdate(action.payload.val());
		} else if (action.type === 'add_item') {
			// local
			definition.localDatabaseUpdate(action.payload.val());
		}
		return definition;
	}

	//get dat prev id in there
	public $$updated(child: CustomFieldDefinition, action: AngularFireAction<DatabaseSnapshot<any>>) {
		super.$$updated(child, action);
	}

	public applyJoinData(
		baseKey: string,
		child: CustomFieldDefinition,
		otherChild: CustomFieldDropDownDefinition
	) {
		switch (baseKey) {
			case 'listOfValuesId':
				child.view.listOfValues = otherChild ? otherChild : null;
				break;
			default:
				break;
		}
	}

	public getDataForKey(baseKey: string, child: CustomFieldDefinition) {
		return child.view[baseKey];
	}
}
